// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAb2y0Xf-rUaRfrDTezBnlGcMtirk3D24g",
  authDomain: "eye-care-4d44a.firebaseapp.com",
  projectId: "eye-care-4d44a",
  storageBucket: "eye-care-4d44a.appspot.com",
  messagingSenderId: "1074518398764",
  appId: "1:1074518398764:web:2ae29744cc7efc4ad3fe89",
};
export default firebaseConfig;
